// Regras de recebimento das maquininhas (prazo e taxa) e a baixa automática que elas alimentam.
import jwtService from "../jwtService";

const BASE_URL = process.env.REACT_APP_API_MODE
  ? process.env.REACT_APP_API_MODE === "production"
    ? process.env.REACT_APP_API_PRODUCAO
    : process.env.REACT_APP_API_MODE === "test"
      ? process.env.REACT_APP_API_TESTE
      : process.env.REACT_APP_API_LOCALHOST
  : process.env.REACT_APP_API_LOCALHOST;

const mensagemDoErro = (error, padrao) =>
  error?.response?.data?.message || error?.data?.message || error?.message || padrao;

class ParametroMaquinaCartaoService {
  async consultarConfiguracaoAutomatica(contexto) {
    const response = await jwtService.getInterceptor().get(
      `${BASE_URL}/maquinas-cartao/configuracao-baixa-automatica`,
      { contextoEmpresaEsperado: contexto },
    );
    return response.data;
  }

  // A decisão pode vir sozinha (só o "ligado/desligado") ou junto com os dias de cada tipo de
  // cartão. Campo vazio vai como nulo de propósito: é o que mantém o prazo da regra da maquininha.
  async salvarConfiguracaoAutomatica(habilitada, contexto, dias = {}) {
    const corpo = {
      habilitada,
      diasCredito: dias.diasCredito ?? null,
      diasDebito: dias.diasDebito ?? null,
    };
    const response = await jwtService.getInterceptor().put(
      `${BASE_URL}/maquinas-cartao/configuracao-baixa-automatica`, corpo,
      { contextoEmpresaEsperado: contexto },
    );
    return response.data;
  }

  async executarAoEntrar(contexto) {
    const response = await jwtService.getInterceptor().post(
      `${BASE_URL}/maquinas-cartao/baixa-automatica-ao-entrar`, null,
      { contextoEmpresaEsperado: contexto },
    );
    return response.data;
  }

  async listarPorMaquina(maquinaCartaoId) {
    try {
      const response = await jwtService
        .getInterceptor()
        .get(`${BASE_URL}/maquinas-cartao/${maquinaCartaoId}/parametros`);
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      throw new Error(mensagemDoErro(error, "Falha ao buscar as regras de recebimento."));
    }
  }

  async salvar(maquinaCartaoId, parametro) {
    try {
      const url = `${BASE_URL}/maquinas-cartao/${maquinaCartaoId}/parametros`;
      const response = parametro.id
        ? await jwtService.getInterceptor().put(`${url}/${parametro.id}`, parametro)
        : await jwtService.getInterceptor().post(url, parametro);
      return response.data;
    } catch (error) {
      throw new Error(mensagemDoErro(error, "Falha ao salvar a regra de recebimento."));
    }
  }

  async excluir(id) {
    try {
      await jwtService.getInterceptor().delete(`${BASE_URL}/maquinas-cartao/parametros/${id}`);
    } catch (error) {
      throw new Error(mensagemDoErro(error, "Falha ao excluir a regra de recebimento."));
    }
  }

  // Com maquinaCartaoId a baixa olha só as contas daquela maquininha (é o que a tela de
  // recebimento dela usa). Sem o id, varre as contas de todas - o mesmo que a rotina diária faz.
  async executarBaixaAutomatica(maquinaCartaoId, dataReferencia) {
    try {
      const query = dataReferencia ? `?dataReferencia=${dataReferencia}` : "";
      const caminho = maquinaCartaoId
        ? `${BASE_URL}/maquinas-cartao/${maquinaCartaoId}/baixa-automatica${query}`
        : `${BASE_URL}/maquinas-cartao/baixa-automatica${query}`;
      const response = await jwtService.getInterceptor().post(caminho);
      return response.data;
    } catch (error) {
      throw new Error(mensagemDoErro(error, "Falha ao executar a baixa automática."));
    }
  }
}

export default new ParametroMaquinaCartaoService();
